export default {
  login: {
    title: "Welcome back",
    // The tab title. The heading is a greeting and does not name the page.
    page_title: "Sign in",
    subtitle: "Sign in to your account to continue",
    form: {
      email: "E-Mail",
      password: "Password",
      submit: "Log in",
    },
    // Only shown to somebody who belongs to more than one workspace, and only after their password
    // has been accepted.
    choose_workspace: "Which workspace would you like to sign in to?",
    back_to_login: "Back to sign in",
    session_expired: "Your session has expired.",
    // Shown after "Switch workspace" in the account menu signed the user out to get them back here.
    switch_workspace: "Enter your password to sign in to a different workspace.",
    // The answer to a 429 from the backend (LoginAttemptThrottle). Deliberately NOT the "wrong
    // password" message: the password was never checked, and may well have been the right one.
    too_many_attempts: "Too many failed sign-in attempts. Please try again in {minutes} minute(s).",
    forgot_password: "Forgot Password?",
    no_account: "You do not have an account yet?",
    create_account: "Create one here.",
  },
  register: {
    title: "Register",
    subtitle: "Create a new Account",
    existing_account:
      "This email address already has an account. Enter its password to add this company to it.",
    steps: {
      account: "Account",
      company: "Company",
    },
    form: {
      back: "Back",
      next: "Next",
      email: "E-Mail",
      firstName: "First name",
      lastName: "Last name",
      password: "Password",
      company: {
        name: "Company Name",
      },
      address: {
        title: "Company Address",
        street: "Street",
        houseNumber: "House number",
        postcode: "Postcode",
        place: "Place",
        country: "Country",
      },
      submit: "Register",
    },
    registerNotice: "With your registration you agree to",
    termsOfUse: "Terms of use",
    privacyPolicy: "Privacy policy",
    alreadyAccount: "Already having an account?",
    loginRedirect: "Log In here.",
  },
  forgot_password: {
    title: "Forgot password",
    subtitle: "Enter your account's email address and we'll send you a link to reset your password.",
    form: {
      email: "E-Mail",
      submit: "Reset password",
    },
    back_to_login: "Back to login.",
    sent: {
      title: "Check your inbox",
      subtitle: "Open the link we sent you by email and reset your account password.",
      resend: "Resend email.",
    },
  },
  reset_password: {
    title: "Enter your new password",
    // The tab title — the heading is an instruction, too long for a tab.
    page_title: "Reset password",
    subtitle: "Set a new password for your account.",
    form: {
      password: "New password",
      submit: "Save new password",
    },
  },
  password_success: {
    title: "Password changed successfully",
    subtitle: "You have successfully changed your password. You can now sign in with your new password.",
    to_login: "Go to login",
  },
}
